import React, { useEffect, useState } from 'react'
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Card, CardBody, CardHeader, Col, Form, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-bs5';
import 'datatables.net-responsive-dt';
import { useApiStore } from '../../hooks/ApiStoreContext';
import dateFormat from "dateformat";
import Swal from 'sweetalert2';


function Order() {
  DataTable.use(DT);
  const apiStore = useApiStore();
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const [orderStatusList, setOrderStatusList] = useState([]);
  const [paymentStatusList, setPaymentStatusList] = useState([]);

  useEffect(() => {
    //getOrderStatus();
    //getPaymentStatus();
    getOrderList();
  }, [])

  
  const getOrderList = async () => {
    try {
      const response = await apiStore.get("/Order");
      //console.log(response);
      setTableData(response);
    } catch (error) {
      if (error.response.status !== 401) {
        console.error("There was an error fetching orders!", error);
      }
    }
  };

  const getOrderStatus = async () => {
    try {
      const response = await apiStore.get("/Order/GetOrderStatusList");
      //console.log(response);      
      setOrderStatusList(response);
    } catch (error) {
      if (error.response.status !== 401) {
        console.error("There was an error fetching order status!", error);
      }
    }
  };

  const getPaymentStatus = async () => {
    try {
      const response = await apiStore.get("/Order/GetPaymentStatusList");
      //console.log(response);
      setPaymentStatusList(response);
    } catch (error) {
      if (error.response.status !== 401) {
        console.error("There was an error fetching payment status!", error);
      }
    }
  };


  const handleView = (e, id) => {
    e.preventDefault();
    //console.log(id);
    navigate('/view-order/' + id);
  }

  const handleOrderStatusChange =  async (e, data, row) => {
    try {
      //console.log(e.target.value);
      //console.log(row.orderId);
      await apiStore.put(`/order/updateOrderStatus/${row.orderId}/${e.target.value}`);
      getOrderList();
    } catch (error) {
      if (error.response.status !== 401) {
        console.error("There was an error updating the order status!", error);
      }
    }

  };

  const handlePaymentStatusChange =  async (e, data, row) => {
    try {
      //console.log(e.target.value);
      //console.log(row.orderId);
      await apiStore.put(`/order/updatePaymentStatus/${row.orderId}/${e.target.value}`);
      getOrderList();
    } catch (error) {
      if (error.response.status !== 401) {
        console.error("There was an error updating the payment status!", error);
      }
    }

  };


  return (
    <Row>
      <Col md={12}>
        <Card className='mb-4'>
          <CardHeader className='pb-0'>
            <Row>
              <Col md={9}>
                <h4>Orders</h4>
              </Col>
              {/* <Col md={3} className='d-grid d-md-flex justify-content-md-end d-sm-block'>
                <Button variant='outline-primary' className='btn-sm' onClick={handleAddProduct}>Add product</Button>
              </Col> */}
            </Row>
          </CardHeader>
          <CardBody className='px-0 pt-0 pb-2'>

            <div className='mx-3'>
              <DataTable className="display table align-items-center mb-0 p-0"
                data={tableData}
                options={{
                  responsive: true,
                  ordering:false,
                  columns: [
                    { data: 'orderId', className: 'text-secondary text-sm font-weight-bold align-middle' },
                    { data: 'user', className: 'text-secondary text-sm font-weight-bold align-middle' },
                    { data: 'user', className: 'text-secondary text-sm font-weight-bold align-middle' },
                    { data: 'orderDate', className: 'text-secondary text-sm font-weight-bold align-middle' },
                    { data: 'subTotal', className: 'text-secondary text-sm font-weight-bold align-middle' },
                    { data: 'totalAmount', className: 'text-secondary text-sm font-weight-bold align-middle' },
                    { data: 'orderStatus', className: 'text-sm font-weight-bold align-middle text-center' },
                    { data: 'paymentStatus', className: 'text-sm font-weight-bold align-middle text-center' },
                    { data: 'orderId', className: 'text-secondary text-sm font-weight-bold align-middle text-center' },
                  ],
                }}
                slots={{
                  1: (data, row) => {
                    return (
                      <React.Fragment>
                        <span >
                          {data.firstName}
                        </span>
                      </React.Fragment>
                    )
                  },
                  2: (data, row) => {
                    return (
                      <React.Fragment>
                        <span >
                          {data.lastName}
                        </span>
                      </React.Fragment>
                    )
                  },
                  3: (data, row) => {
                    return (
                      <React.Fragment>
                        <span >
                          {dateFormat(data, "dd/mm/yyyy")}
                        </span>
                      </React.Fragment>
                    )
                  },
                  6: (data, row) => {
                    return (
                      <React.Fragment>
                        <Form.Select key={"orderStatus_"+row.orderId} id={"orderStatus_"+row.orderId} value={data} onChange={(e) => handleOrderStatusChange(e, data, row)}>
                          <option value="">Select</option>
                          {/* {
                            orderStatusList.map((os) => (
                              <option key={os.id} value={os.id}>
                                {os.name}
                              </option>
                            ))
                          } */}
                          <option value="1">Order Placed</option>
                          <option value="2">Processing</option>
                          <option value="3">Shipped</option>
                          <option value="4">Delivered</option>
                          <option value="5">Cancelled</option>
                          <option value="6">Returned</option>
                        </Form.Select>
                      </React.Fragment>
                    )
                  },
                  7: (data, row) => {
                    return (
                      <React.Fragment>
                        <Form.Select key={"paymentStatus_" + row.orderId} id={"paymentStatus_" + row.orderId} value={data} onChange={(e) => handlePaymentStatusChange(e, data, row)}>
                          <option value="">Select</option>
                          {/* {
                            paymentStatusList.map((os) => (
                              <option key={os.id} value={os.id}>
                                {os.name}
                              </option>
                            ))
                          } */}
                          <option value="1">Pending</option>
                          <option value="2">Paid</option>
                          <option value="3">Refunded</option>
                        </Form.Select>
                      </React.Fragment>
                    )
                  },
                  8: (data, row) => {
                    return (
                      <React.Fragment>
                        <a className='me-3 cursor-pointer' title='View order details' onClick={(e) => handleView(e, data)} >
                          <FontAwesomeIcon icon={faEye} size='lg'></FontAwesomeIcon>
                        </a>
                      </React.Fragment>
                    );
                  },
                }}
              >
                <thead>
                  <tr>
                    <th className="text-uppercase text-secondary text-sm font-weight-bolder">Order Id</th>
                    <th className="text-uppercase text-secondary text-sm font-weight-bolder">Company Name</th>
                    <th className="text-uppercase text-secondary text-sm font-weight-bolder">Contact Person</th>
                    <th className="text-uppercase text-secondary text-sm font-weight-bolder">Order date</th>
                    <th className="text-uppercase text-secondary text-sm font-weight-bolder">Sub Total</th>
                    <th className="text-uppercase text-secondary text-sm font-weight-bolder">Total Amount</th>
                    <th className="text-uppercase text-secondary text-sm font-weight-bolder">Order status</th>
                    <th className="text-center text-uppercase text-secondary text-sm font-weight-bolder">Payment status</th>
                    <th className="text-center text-uppercase text-secondary text-sm font-weight-bolder">Action</th>
                  </tr>
                </thead>
              </DataTable>
            </div>

          </CardBody>

        </Card>
      </Col>
    </Row>
  )
}

export default Order